FrameModules.add('WikiHelpSidebarFrameModule', function() {
   var sidebar = $('wikiHelpSidebar'),
      sectionSelector = '.subSection ul',
      displaySection;

   var linkSelector = "a[href$='" + window.location.pathname + "']",
      linkToThisPage = sidebar.getElements(linkSelector)[0];

   if (linkToThisPage) {
      displaySection = linkToThisPage.getParent(sectionSelector);
   }

   var accordion = new Fx.Accordion(sidebar, '.subSection', sectionSelector, {
      duration: 250,
      display: displaySection,
      initialDisplayFx: false,
      onActive: function(toggler) {
         toggler.addClass('highlight');
      },
      onBackground: function(toggler) {
         toggler.removeClass('highlight');
      },
   });
});
